import { useSyncExternalStore } from 'react';

/// Onde a tabela cede o lugar aos cards. É o `md` do Tailwind, escrito em pixel para não depender
/// do tamanho da fonte-raiz: a listagem precisa trocar de forma no MESMO ponto em que as classes
/// `md:` das telas trocam.
const WIDE_VIEWPORT = '(min-width: 768px)';

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(WIDE_VIEWPORT);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isWide(): boolean {
  return window.matchMedia(WIDE_VIEWPORT).matches;
}

/// Diz se cabe a tabela.
///
/// A alternativa seria montar tabela e cards e esconder um com `md:hidden` — mas aí as duas formas
/// ficam no documento: com 200 lançamentos são 200 linhas renderizadas duas vezes, e o leitor de
/// tela lê a lista inteira em dobro. Aqui só a forma que cabe existe.
export function useIsWideViewport(): boolean {
  return useSyncExternalStore(subscribe, isWide, () => true);
}
